export type IExtraData = {
  propertyId?: number;
};

export enum EField {
  Property = "property",
}
